import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { useAuth } from './auth.js';
import { LoginScreen } from './components/LoginScreen.js';
import { SetupWizard } from './components/SetupWizard.js';
import { AppShell } from './components/AppShell.js';
import { TemperatureSection } from './components/TemperatureSection.js';
import { VideoSection } from './components/VideoSection.js';
import { InfosSection } from './components/InfosSection.js';
import { MemoriesSection } from './components/MemoriesSection.js';
import { RuntimeView } from './components/RuntimeView.js';
import { t } from './i18n.js';

export function App() {
  const { state } = useAuth();
  if (state === 'loading') return <div className="app"><div className="center-state">{t('app.loading')}</div></div>;
  if (state === 'setup-required') return <SetupWizard />;
  if (state === 'logged-out') return <LoginScreen />;

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/temperature" element={<TemperatureSection />} />
          <Route path="/video" element={<VideoSection />} />
          <Route path="/infos" element={<InfosSection />} />
          <Route path="/souvenirs" element={<MemoriesSection />} />
          <Route path="/conso" element={<RuntimeView />} />
        </Route>
        <Route path="*" element={<Navigate to="/temperature" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
